var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.508 21.542L0.472 21.542 0.472 0.458 10.848 0.458 16.508 5.958z",
    transform: "translate(-174 -418) translate(161 405) translate(13.016 13) translate(3.995 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.848 0.458L10.848 5.958 16.508 5.958",
    transform: "translate(-174 -418) translate(161 405) translate(13.016 13) translate(3.995 1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.245 6.875L8.49 6.875M4.245 9.625L12.735 9.625M4.245 12.375L12.735 12.375M4.245 15.125L12.735 15.125M4.245 17.875L12.735 17.875",
    transform: "translate(-174 -418) translate(161 405) translate(13.016 13) translate(3.995 1)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.3a8bb2f9.svg";
export { ForwardRef as ReactComponent };